// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__2HrBE","dragIcon":"SortableItem_dragIcon__PR8k-","disabled":"SortableItem_disabled__1cZpq"};